/**
 * PATH: packages/document-editor/src/imageExtension.ts
 * FILE_ID: DOCEDITOR-IMAGE-EXTENSION-001
 * PURPOSE: FileRecord-aware image node with safe, portable JSON attributes.
 * WHY: Documents reference managed files without embedding arbitrary markup.
 * RELATED: contracts.ts
 */
import { Image } from '@tiptap/extension-image'
import { isSafeDocumentUrl } from './contracts'

export const DocumentImage = Image.extend({
  parseHTML() {
    return [{ tag: 'img[data-file-id]' }, { tag: 'img[src]' }]
  },
  addAttributes() {
    return {
      ...this.parent?.(),
      src: {
        default: null,
        parseHTML: (element) => {
          const value = element.getAttribute('src')
          return isSafeDocumentUrl(value) ? value : null
        },
        renderHTML: (attrs) => isSafeDocumentUrl(attrs.src) ? { src: String(attrs.src) } : {},
      },
      fileId: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-file-id'),
        renderHTML: (attrs) => attrs.fileId ? { 'data-file-id': String(attrs.fileId) } : {},
      },
      url: {
        default: null,
        parseHTML: (element) => {
          const value = element.getAttribute('src')
          return isSafeDocumentUrl(value) ? value : null
        },
        renderHTML: (attrs) => isSafeDocumentUrl(attrs.url)
          ? { src: String(attrs.url) }
          : {},
      },
      width: {
        default: null,
        parseHTML: (element) => element.getAttribute('width') || element.style.width || null,
        renderHTML: (attrs) => attrs.width ? { width: String(attrs.width) } : {},
      },
      align: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-align'),
        renderHTML: (attrs) => ['left', 'center', 'right'].includes(String(attrs.align))
          ? { 'data-align': String(attrs.align) }
          : {},
      },
    }
  },
}).configure({
  inline: false,
  allowBase64: false,
  HTMLAttributes: { class: 'qdoc-image' },
})
